export const PUZZLE_VISIBLE_REPLY_LIMIT = 2;

export type PuzzleCommentFocusNode = {
    id?: string | null;
    replies?: PuzzleCommentFocusNode[];
};

function containsCommentId(node: PuzzleCommentFocusNode, targetCommentId: string): boolean {
    if (node.id != null && String(node.id) === targetCommentId) {
        return true;
    }
    if (!Array.isArray(node.replies)) {
        return false;
    }
    return node.replies.some((reply) => containsCommentId(reply, targetCommentId));
}

/**
 * Returns comment ids whose reply lists must expand before the focus comment is in the DOM.
 * Includes top-level threads and nested reply parents at any depth.
 */
export function findCommentIdsRequiringReplyExpansion(
    focusCommentId: string,
    comments: PuzzleCommentFocusNode[],
): Set<string> {
    const commentIds = new Set<string>();
    const walkReplies = (parentCommentId: string, replies: PuzzleCommentFocusNode[]): void => {
        replies.forEach((reply, index) => {
            const replyId = reply.id != null ? String(reply.id) : null;
            const isHiddenReply = index >= PUZZLE_VISIBLE_REPLY_LIMIT;
            if (isHiddenReply && replyId === focusCommentId) {
                commentIds.add(parentCommentId);
            }
            if (isHiddenReply && containsCommentId(reply, focusCommentId)) {
                commentIds.add(parentCommentId);
            }
            if (Array.isArray(reply.replies) && reply.replies.length > 0 && replyId) {
                walkReplies(replyId, reply.replies);
            }
        });
    };
    for (const comment of comments) {
        const commentId = comment.id != null ? String(comment.id) : null;
        if (!commentId) {
            continue;
        }
        if (commentId === focusCommentId) {
            return commentIds;
        }
        if (Array.isArray(comment.replies) && comment.replies.length > 0) {
            walkReplies(commentId, comment.replies);
        }
    }
    return commentIds;
}
